(() => {
  if (window.bbPersonalizerUI) {
    window.bbPersonalizerUI();
    return;
  }
  const config = document.querySelector('script[data-bbp-editor-heading]');
  const heading = config?.dataset.bbpEditorHeading || document.querySelector('.product-page-info .pplr-c-button')?.textContent.trim() || '';
  const detailsHeading = config?.dataset.bbpEditorDetails || '';
  const productTitle = document.querySelector('.product-page-info__title h1')?.textContent.trim() || '';
  const mobile = window.matchMedia('(max-width: 768px)');
  const actionPositions = new WeakMap();
  let scheduled = false;
  const visible = element => element.getClientRects().length > 0;
  const update = () => {
    scheduled = false;
    document.querySelectorAll('.pplr-modal-box:not(.pplr-crop-mode)').forEach(modal => {
      const form = modal.querySelector('.pplr_atc_form');
      const header = modal.querySelector(':scope > .p_h_d');
      const action = form?.querySelector('.pplr_ex_button');
      if (!form || !header || !action) return;
      const panel = form.querySelector('.pplr-p-right');
      if (panel) {
        if (mobile.matches && action.parentElement !== panel) {
          if (!actionPositions.has(action)) {
            const position = document.createTextNode('');
            action.before(position);
            actionPositions.set(action, position);
          }
          panel.append(action);
        } else if (!mobile.matches && actionPositions.has(action)) {
          const position = actionPositions.get(action);
          if (position.isConnected) position.replaceWith(action);
          actionPositions.delete(action);
        }
      }
      if (mobile.matches) {
        const viewport = window.visualViewport;
        const height = `${Math.round(viewport?.height || window.innerHeight)}px`;
        const top = `${Math.round(viewport?.offsetTop || 0)}px`;
        if (modal.style.getPropertyValue('--bbp-viewport-height') !== height) modal.style.setProperty('--bbp-viewport-height', height);
        if (modal.style.getPropertyValue('--bbp-viewport-top') !== top) modal.style.setProperty('--bbp-viewport-top', top);
      }
      if (!header.querySelector('.bbp-editor-heading')) {
        const title = document.createElement('h2');
        title.className = 'bbp-editor-heading';
        title.textContent = heading;
        const subtitle = document.createElement('p');
        subtitle.className = 'bbp-editor-product';
        subtitle.textContent = productTitle;
        header.prepend(title, subtitle);
      }
      const body = form.querySelector('.pplr-modal-body');
      if (body && detailsHeading && !body.querySelector('.bbp-editor-details')) {
        const details = document.createElement('h3');
        details.className = 'bbp-editor-details';
        details.textContent = detailsHeading;
        body.prepend(details);
      }
      const labels = [...form.querySelectorAll('.oindexlabel')].filter(label => /preview is approximate/i.test(label.textContent));
      const current = labels.find(label => visible(label.closest('.pplr-wrapper') || label)) || labels[0];
      if (current) {
        let note = action.querySelector('.bbp-editor-note');
        if (!note) {
          note = document.createElement('p');
          note.className = 'bbp-editor-note';
          action.append(note);
        }
        const text = current.textContent.trim();
        if (note.textContent !== text) note.textContent = text;
        labels.forEach(label => {
          if (!label.hasAttribute('data-bbp-note-relocated')) label.setAttribute('data-bbp-note-relocated', '');
        });
      }
      const tabs = form.querySelector('.pplr_tab_wrapper');
      if (tabs) {
        const single = [...tabs.children].filter(tab => !tab.hidden && getComputedStyle(tab).display !== 'none').length === 1;
        if (tabs.classList.contains('bbp-single-view') !== single) tabs.classList.toggle('bbp-single-view', single);
      }
      if (modal.classList.contains('pplr-has-view-arrows')) {
        const stage = modal.querySelector('.pplr-p-left');
        const views = [...(stage?.querySelectorAll('.pplr-dot') || [])];
        if (views.length > 1) {
          let count = stage.querySelector('.bbp-view-count');
          if (!count) {
            count = document.createElement('span');
            count.className = 'bbp-view-count';
            count.setAttribute('aria-hidden', 'true');
            stage.append(count);
          }
          const index = Math.max(0, views.findIndex(view => view.classList.contains('active')));
          const text = `${index + 1} / ${views.length}`;
          if (count.textContent !== text) count.textContent = text;
        }
      }
      if (!modal.classList.contains('bbp-editor-ready')) modal.classList.add('bbp-editor-ready');
    });
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  };
  const observer = new MutationObserver(records => {
    if (records.some(record => {
      if (record.type === 'attributes') return record.target.matches('.pplr-modal-box, .pplr_tab, .pplr_tab_index, .pplr-wrapper, .pplr-dot');
      return record.target.closest?.('.pplr-modal-box') || [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('.pplr-modal-box') || node.querySelector('.pplr-modal-box')));
    })) schedule();
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
  mobile.addEventListener('change', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  window.visualViewport?.addEventListener('resize', schedule, { passive: true });
  window.visualViewport?.addEventListener('scroll', schedule, { passive: true });
  window.bbPersonalizerUI = schedule;
  update();
})();
